<template>
  <div>
    <div class="flex flex-col items-stretch">
      <div
        v-if="!value.length"
        class="mb-2 flex items-center"
      >
        <div class="mr-2">{{ label }}</div>
        <BaseInfoTooltip><slot /></BaseInfoTooltip>
      </div>
      <file-upload
        v-bind="$attrs"
        :ref="inputRef"
        :value="value"
        :size="10 * 1024 * 1024"
        :drop="true"
        :add-index="false"
        :class="{'border-2': !value.length && !previousValue}"
        class="rounded pt-4 flex border-dashed custom-border-color md:pt-0 custom-cursor"
        @input="$emit('input', $event)"
      >
        <div
          v-if="value[0] || previousValue"
          class="flex justify-between"
        >
          <div class="flex w-3/4 overflow-hidden">
            <div
              class="mr-5"
              style="width:50px; min-width: 50px"
            >
              <img
                v-if="value[0]"
                :src="value[0].blob"
                width="50"
              >
              <img
                v-else
                :src="previousValue.thumbnail"
                width="50"
              >
            </div>
            <div class="text-left overflow-hidden">
              <div class="text-grey text-sm pt-2">{{ label }}</div>
              <div class="text-dark-grey text-lg overflow-hidden text-ellipsis whitespace-no-wrap">
                <template v-if="value[0]">
                  {{ value[0].name }}
                </template>
                <template v-else>
                  {{ previousValue.filename }}
                </template>
              </div>
            </div>
          </div>
          <div class="text-grey text-lg self-end leading-loose">
            {{ $t('Edit') }}
          </div>
        </div>
        <div
          v-else
          class="md:py-10"
        >
          <DocumentUpload class="mb-4" />
          <div class="text-black text-sm font-heavy mb-1">
            {{ $t('Upload a file') }}
          </div>
          <div class="text-sm font-sans-medium text-grey mb-2">
            PDF, JPG, PNG, max 10MB
          </div>
        </div>
      </file-upload>
    </div>
  </div>
</template>

<script>
import DocumentUpload from './icons/DocumentUpload.vue';
import BaseInfoTooltip from './BaseInfoTooltip.vue';

export default {
  name: 'BaseDocumentInput',
  components: {
    DocumentUpload,
    BaseInfoTooltip,
  },
  inheritAttrs: false,
  props: {
    inputRef: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
    previousValue: {
      type: Object,
      default: null,
    },
  },
  methods: {
    inputFile(newFile) {
      this.$emit('input', newFile);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-border-color {
  border-color: rgba(122, 131, 142, 0.7);
}
.text-ellipsis {
  text-overflow: ellipsis;
}
</style>

<style>
.custom-cursor label {
  cursor: pointer;
}
</style>
